import { apiGet, apiPost, throwApiError } from "../utils";

export const RefundRequestStatus = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "rejected",
  Cancelled: "cancelled",
};

export const RefundReason = {
  HostDidNotApprove: "host_did_not_approve",
  TechnicalIssue: "technical_issue",
  AudioVideoProblem: "audio_video_problem",
  DuplicateCharge: "duplicate_charge",
  Other: "other",
};

export const RefundReasonLabels = {
  [RefundReason.HostDidNotApprove]: "Host Did Not Approve",
  [RefundReason.TechnicalIssue]: "Technical Issue",
  [RefundReason.AudioVideoProblem]: "Audio/Video Problem",
  [RefundReason.DuplicateCharge]: "Duplicate Charge",
  [RefundReason.Other]: "Other",
};

export const getRefundRequests = async (
  page,
  perPage,
  search = "",
  filters = {},
) => {
  const params = { page, perPage };

  if (search) {
    params.search = search;
  }

  if (filters.status) {
    params.status = filters.status;
  }

  const response = await apiGet("/refund-requests", params);
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getRefundRequestById = async (id) => {
  const response = await apiGet(`/refund-requests/${id}`);
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};

export const approveRefundRequest = async (id, resolutionNote) => {
  const response = await apiPost(`/refund-requests/${id}/approve`, {
    resolutionNote: resolutionNote || undefined,
  });
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};

export const rejectRefundRequest = async (id, resolutionNote) => {
  const response = await apiPost(`/refund-requests/${id}/reject`, {
    resolutionNote: resolutionNote || undefined,
  });
  const { message, ...request } = await response.json();

  throwApiError(message);

  return request;
};
